export interface LoginFormFields {
    username: string;
    password: string;
    keepLoggedIn: boolean;
    recaptchaToken: string | null;
}

export const LOGIN_DEFAULTS: LoginFormFields = {
    username: '',
    password: '',
    keepLoggedIn: true,
    recaptchaToken: null,
};
